
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-quiz-answer-tile',
    imports: [],
    templateUrl: './quiz-answer-tile.component.html',
    styleUrl: './quiz-answer-tile.component.scss'
})
export class QuizAnswerTileComponent {
  @Input() answerText: string = '';
  @Input() isSelected: boolean = false;
  @Input() answerId!: string;
  @Output() selectionChange = new EventEmitter<string>();

  toggleSelection() {
    this.selectionChange.emit(this.answerId);
  }
}